// Import model
import { BomKitItemCondition } from '../models/BomKitItemCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { BomKitItemIndexedFields } from '../models/BomKitItemIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { BomKitItemIndexedFieldsSerializer } from './BomKitItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for BomKitItemCondition - handles JSON serialization and deserialization with type validation
 */
export class BomKitItemConditionSerializer {
  /**
   * Deserializes a JSON string into a BomKitItemCondition instance
   */
  static deserialize(json: string): BomKitItemCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a BomKitItemCondition instance
   */
  static fromObject(obj: any): BomKitItemCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to BomKitItemCondition');
    }


    const instance: BomKitItemCondition = {
      fieldName: obj['fieldName'] as BomKitItemIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of BomKitItemCondition instances
   */
  static deserializeArray(json: string): BomKitItemCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a BomKitItemCondition instance to a JSON string
   */
  static serialize(instance: BomKitItemCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a BomKitItemCondition instance to a plain object
   */
  static toObject(instance: BomKitItemCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of BomKitItemCondition instances to a JSON string
   */
  static serializeArray(instances: BomKitItemCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
